import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between" },
            [
              _c(
                VBtn,
                {
                  staticClass: "my-auto",
                  attrs: { outlined: "" },
                  on: { click: _vm.goBack },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.base.back")) +
                      " "
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex justify-end align-center" },
                [
                  _c("qr-scanner", {
                    staticClass: "mr-2",
                    attrs: {
                      manualProcess: true,
                      title: _vm.$vuetify.lang.t(
                        "$vuetify.packaging.scanToVerify"
                      ),
                    },
                    on: { captured: _vm.processScannedEntry },
                  }),
                  _c(VSwitch, {
                    attrs: {
                      label: _vm.$vuetify.lang.t(
                        "$vuetify.packaging.hideVerified"
                      ),
                    },
                    model: {
                      value: _vm.hideVerified,
                      callback: function ($$v) {
                        _vm.hideVerified = $$v
                      },
                      expression: "hideVerified",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.filteredEntries
            ? _c("div", { staticClass: "text-center text-caption" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.packaging.nPendingVerification",
                        _vm.filteredEntries.length
                      )
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm._l(_vm.filteredEntries, function (entry) {
            return _c(
              VSheet,
              {
                key: entry.id,
                staticClass: "ma-4 pa-4",
                attrs: { elevation: 2 },
              },
              [
                _c("div", { staticClass: "d-flex justify-space-between" }, [
                  !entry.uploadFiles || entry.uploadFiles.length < 1
                    ? _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(_vm._s(_vm.entryIndex(entry)) + "."),
                          ]),
                          _c(VCheckbox, {
                            on: {
                              change: function ($event) {
                                return _vm.saveEntry(entry)
                              },
                            },
                            model: {
                              value: entry.verified,
                              callback: function ($$v) {
                                _vm.$set(entry, "verified", $$v)
                              },
                              expression: "entry.verified",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !entry.uploadFiles || entry.uploadFiles.length < 1
                    ? _c(
                        "div",
                        { staticClass: "my-auto flex-grow-1 text-center" },
                        [
                          entry.unitCode
                            ? _c("div", { staticClass: "font-weight-bold" }, [
                                _c("span", [
                                  _vm._v(" " + _vm._s(entry.unitCode) + " "),
                                ]),
                              ])
                            : _vm._e(),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatNumber")(entry.netWeight)
                                ) +
                                " " +
                                _vm._s(
                                  _vm.productInfo
                                    ? _vm.productInfo.measureWeight
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "text-caption" }, [
                            entry.inventoryId
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewSelectedInventory(entry)
                                      },
                                    },
                                  },
                                  [
                                    entry.documentNumber
                                      ? _c("div", [
                                          _vm._v(
                                            " Doc #: " +
                                              _vm._s(entry.documentNumber) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c("div", [
                                      _vm._v(
                                        "Inventory ID: " +
                                          _vm._s(entry.inventoryId)
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "my-auto" },
                    [
                      _c("image-upload", {
                        key: `${entry.id}-${_vm.addTime}`,
                        staticClass: "mt-4 mx-2",
                        model: {
                          value: entry.uploadFiles,
                          callback: function ($$v) {
                            _vm.$set(entry, "uploadFiles", $$v)
                          },
                          expression: "entry.uploadFiles",
                        },
                      }),
                      _c("div", { staticClass: "text-center" }, [
                        entry.files && entry.files.length > 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  VBtn,
                                  {
                                    attrs: { text: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showImages(entry)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(entry.files.length) + " File")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          [
                            entry.uploadFiles && entry.uploadFiles.length > 0
                              ? _c(
                                  VBtn,
                                  {
                                    attrs: { outlined: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.uploadFiles(
                                          entry.id,
                                          entry.uploadFiles
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Upload")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-caption mt-2 d-flex justify-space-between",
                  },
                  [
                    _c("div", [
                      entry.verified
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.packaging.verifiedOn",
                                    _vm.$options.filters.formatDateTime(
                                      entry.verifiedOn
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm._f("formatDateTime")(entry.updateTime))
                      ),
                    ]),
                  ]
                ),
              ]
            )
          }),
          _c(
            VDialog,
            {
              staticStyle: { "z-index": "1000" },
              model: {
                value: _vm.imgDialog,
                callback: function ($$v) {
                  _vm.imgDialog = $$v
                },
                expression: "imgDialog",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(VCardTitle, { staticClass: "justify-end" }, [
                    _c(
                      "div",
                      [
                        _c(
                          VBtn,
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.imgDialog = null
                              },
                            },
                          },
                          [_c(VIcon, [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    VCardText,
                    [
                      _vm.images && _vm.images.length > 0
                        ? _c(
                            VCarousel,
                            { attrs: { height: "auto" } },
                            _vm._l(_vm.images, function (img, i) {
                              return _c(
                                VCarouselItem,
                                {
                                  key: i,
                                  attrs: {
                                    "reverse-transition": "fade-transition",
                                    transition: "fade-transition",
                                  },
                                },
                                [
                                  _c(VImg, {
                                    attrs: {
                                      contain: "",
                                      "aspect-ratio": "1.7",
                                      src: img.src,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-right text-caption ma-2",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatDateTime")(img.time)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "text-subtitle-2 font-weight-light",
                            },
                            [_vm._v(" No attachments found ")]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VBottomSheet,
            {
              attrs: { scrollable: "" },
              model: {
                value: _vm.showInventoryDetails,
                callback: function ($$v) {
                  _vm.showInventoryDetails = $$v
                },
                expression: "showInventoryDetails",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    { staticClass: "justify-center" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "mt-6",
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.showInventoryDetails = false
                            },
                          },
                        },
                        [_vm._v(" close ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c("inventory-details", {
                        key: _vm.selectedInventory
                          ? _vm.selectedInventory.id
                          : 0,
                        model: {
                          value: _vm.selectedInventory,
                          callback: function ($$v) {
                            _vm.selectedInventory = $$v
                          },
                          expression: "selectedInventory",
                        },
                      }),
                      _vm.selectedInventoryUnit
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-center text-subtitle-1 my-2 font-weight-light",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        this.$vuetify.lang.t(
                                          "$vuetify.worksheet.selectedUnit"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(VSimpleTable, { staticClass: "table" }, [
                                _c("tr", [
                                  _c("td", [_vm._v("Code")]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.selectedInventoryUnit.code)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      " # of " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureUnit
                                            : "Unit"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedInventoryUnit.unitShare
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureUnit
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      " Weight per " +
                                        _vm._s(
                                          _vm.productInfo
                                            ? _vm.productInfo.measureUnit
                                            : "Unit"
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.selectedInventoryUnit
                                              .amountPerUnit
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.selectedInventoryUnit.unitMeasure
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }